var map = {
	"./bellecose.png": 2005,
	"./burger-king.png": 73,
	"./comune-pantelleria.png": 3492,
	"./croccante.png": 7140,
	"./daab.png": 4202,
	"./dat.png": 9964,
	"./deejay.png": 8097,
	"./fta.png": 1086,
	"./fuzetea.png": 6377,
	"./lost-boys.png": 4540,
	"./meraqui.png": 8539,
	"./musa.png": 834,
	"./pantelleria-island.png": 1751,
	"./ploom.png": 6681,
	"./sammontana.png": 2106,
	"./sesiventi.png": 6229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7263;